<script lang="ts" setup>
import CategoryItem from '@/pages/services/components/CategoryItem.vue'
const props = defineProps({
  disableIndex: {
    type: Number,
    default: 0
  }
})
const lists = ref([
  {
    image: './images/services/repair.jpg',
    title: '產品維修',
    link: '/services/repair',
    rotate: 0
  },
  {
    image: './images/services/warranty.jpg',
    title: '保固註冊',
    link: '/services/warranty',
    rotate: 0
  },
  {
    image: './images/services/inhome.jpg',
    title: '申請一般維修',
    link: '/services/repair/form',
    rotate: 0
  },
  {
    image: './images/services/selection.jpg',
    title: '選品服務',
    link: '/services/select',
    rotate: 0
  },
  {
    image: './images/services/cleaning.jpg',
    title: '深層清潔',
    link: '/services/cleaning',
    rotate: 0
  }
])
</script>

<template>
  <div class="other">
    <div class="other__intro">
      <Intro subtitle="service" :data="{
        title: '其他服務'
      }" class="align-left display80" />
    </div>
    <div class="other__content">
      <ul class="lists">
        <template v-for="(item, index) in lists" :key="index">
          <li v-if="index !== props.disableIndex">
            <CategoryItem :data="{ ...item }" />
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.other {
  @include grid;

  &__intro {
    grid-column: 1 / span 12;
  }

  &__content {
    grid-column: 4 / span 8;

    @include max-media(990) {
      grid-column: 1 / span 12;
    }
  }

  .lists {
    display: grid;
    grid-template-columns: repeat(auto-fill, calc((100% - toRem(72)) / 4));
    column-gap: toRem(24);

    @include max-media(767) {
      grid-template-columns: repeat(auto-fill, calc((100% - toRem(48)) / 2));
    }

    li {
      @include max-media(767) {
        margin-bottom: toRem(24);
      }
    }
  }
}
</style>
